import { render, staticRenderFns } from "./RecipeTargetRateUpdateForm.vue?vue&type=template&id=54d1a33b&scoped=true"
import script from "./RecipeTargetRateUpdateForm.vue?vue&type=script&lang=js"
export * from "./RecipeTargetRateUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeTargetRateUpdateForm.vue?vue&type=style&index=0&id=54d1a33b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d1a33b",
  null
  
)

export default component.exports